<template>
<!-- 规格信息 -->
  <div class="module-info">
    <div
      class="specifications-add"
      @click="addSpecifications"
      v-if="moduleState != 2"
    >
      <i class="el-icon-circle-plus-outline"></i>
      {{ $t("pages.equipment.text46") }}
    </div>
    <div
      class="specifications-ul"
      v-for="(item, index) in bikeTypeFormatInfo"
      :key="index"
    >
      <div class="specifications-title">
        <i
          class="el-icon-remove-outline"
          @click="remove(index)"
          v-if="moduleState != 2"
        ></i>
        {{ $t("pages.equipment.text47") }}{{ index + 1 }}
      </div>
      <el-form
        :model="item"
        ref="ruleForm"
       label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.equipment.text48')" prop="region">
          <el-input
            v-model="item.color"
            :disabled="moduleState == 2"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text49')" prop="region">
          <el-input
            v-model="item.wheelSize"
            :disabled="moduleState == 2"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text50')" prop="region">
          <el-input
            v-model="item.endurance"
            :disabled="moduleState == 2"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bikeTypeFormatInfo: [
        {
          color: "", //颜色
          wheelSize: "", //轮径
          endurance: "", //续航
        },
      ],
    };
  },
  watch: {
    bikeTypeFormatInfo: {
      handler: function () {
        this.$emit("mergeParams", {
          bikeTypeFormatInfo: this.bikeTypeFormatInfo,
        });
      },
      deep: true,
    },
    activeName: {
      immediate: true,
      handler: function () {
        this.bikeTypeFormatInfo = this.params.bikeTypeFormatInfo;
      },
      deep: true,
    },
  },
  props: ["activeName", "params", "moduleState"],
  methods: {
    //新增规格
    addSpecifications() {
      if (this.moduleState == 2) {
        return;
      }
      if (this.bikeTypeFormatInfo.length >= 10) {
        return this.$message({
          message: this.$t("pages.equipment.text51"),
          type: "warning",
        });
      }
      let specifications = {
        color: "",
        wheelSize: "",
        endurance: "",
      };
      this.bikeTypeFormatInfo.push(specifications);
    },
    //删除规格
    remove(e) {
      if (this.moduleState == 2) {
        return;
      }
      this.bikeTypeFormatInfo.splice(e, 1);
    },
  },
};
</script>

<style scoped>
.module-info {
  width: 80%;
}
.module-info i {
  font-size: 20px;
  color: #1f5bcc;
  margin-right: 10px;
}
.specifications-ul {
  display: flex;
  flex-direction: column;
}
.specifications-title {
  font-size: 18px;
  margin-left: 30px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.specifications-add {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-left: 30px;
  margin-bottom: 20px;
  color: #1f5bcc;
  cursor: pointer;
}
</style>